module.exports = function (fox, _publicPath_) {
 /* fox-dynamic-injection */ 
fox.registerTemplate("big_preloader", [["div",{"class":"mc-preloader-wrapper"},[["div",{"id":"spin-wrap"},[["span",{"class":"loading-text","data-fox-alias":"1","data-fox-context":"big_preloader"},[["textNode",{"text":"Loading..."}]]],["div",{"id":"spin"}]]]]]]);
fox.registerTemplate("small_preloader", [["div",{"id":"spin-wrap","class":"sm"},[["div",{"id":"spin"}]]]]);
 /* fox-dynamic-injection */ 
};


//////////////////
// WEBPACK FOOTER
// /var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-dynamic-injection!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/node_modules/fox-template-loader!/var/www/jenkins.devel.ac/workspace/MC_Frontend_Rollout/admin/common/frame/templates/preloader.tpl
// module id = 62
// module chunks = 5